import Repository from '../../../Repository';
import { computed } from 'vue';
import store from '@/store';
import { useToast } from 'vue-toastification';
import { serialize } from 'object-to-formdata';

const company = computed(() => store.getters['company/info']);
const toast = useToast();

export default {
	update(payload) {
		const formData = serialize(payload, { indices: true, nullsAsUndefineds: true });
		formData.append('_method', 'PUT');

		return Repository.post(`/company/${company.value.id}/admin/company`, formData, { headers: { 'Content-Type': 'multipart/form-data' }}).then((response) => {
			toast.success(`Perfil actualizado correctamente.`);
			return response;
		});
	},
	config(payload) {
		return Repository.put(`/company/${company.value.id}/admin/company/config`, payload).then((response) => {
			toast.success(`Configuración actualizada correctamente.`);
			return response;
		});
	}
}